import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_get_inbound_lp_details_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get($inParams: { licensePlateId: number, numberOfCopies?: number }): Promise<{ result?: { labels?: { id?: number, projectLookupCode?: string, orderLookupCode?: string, materialLookupCode?: string, vendorLotExpirationDate?: string, lotLookupCode?: string, actualTargetLicensePlateLookupCode?: string }[] } }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.licensePlateId)) {
      $missingRequiredInParams.push('\'licensePlateId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      licensePlateId: number, numberOfCopies?: number    }) {
        if(isNil($inParams.licensePlateId)) {
          return true; 
        }
      return false;
    }
}
